import { Validators } from '@angular/forms';

import { nationalCodeValidator } from '../validators/national-code-validator';
import { RegularExpressions } from './regular-expressions';

export const Validator = {
  mobile: [
    Validators.required,
    Validators.pattern(RegularExpressions.mobileNumberPrefixTo98),
    Validators.pattern(RegularExpressions.justNumber),
  ],
  phone: [
    Validators.required,
    Validators.maxLength(11),
    Validators.pattern(RegularExpressions.justNumber),
  ],
  zipCode: [
    Validators.required,
    Validators.maxLength(10),
    Validators.minLength(10),
    Validators.pattern(RegularExpressions.justNumber),
  ],
  nationalCode: [
    Validators.required,
    Validators.maxLength(10),
    Validators.minLength(10),
    nationalCodeValidator(),
    Validators.pattern(RegularExpressions.justNumber),
  ],
  url: [Validators.required, Validators.pattern(RegularExpressions.url)],
};
